import getElementPosition from '../../shared/utilities/getElementPosition';
import { ErrorsInterface } from '../modules/personalInfo/types/errorInput.types';

const getFirstFieldError = (fields: ErrorsInterface): HTMLElement | null => {
  const keys = Object.keys(fields);
  const firstKey = keys.sort((key1, key2) => {
    const firstElem = document.getElementById(key1);
    const secondElem = document.getElementById(key2);
    if (firstElem !== null && secondElem !== null) {
      return getElementPosition(firstElem).y - getElementPosition(secondElem).y;
    }
    return 1;
  })[0];
  const elem = document.getElementById(firstKey);

  return elem;
};

export default getFirstFieldError;
